var _g, _g2, _rect, _rect2, _rect3, _rect4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlashcodeIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 344,
    height: 362,
    viewBox: "0 0 344 362",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -2.35806,
    y: 31.788,
    width: 267,
    height: 332,
    rx: 50,
    transform: "rotate(-8.21836 -2.35806 31.788)",
    fill: "#211E1E"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.0158 56.5312C69.2778 29.1103 94.1512 9.5256 121.572 12.7876L295.347 33.46C322.768 36.722 342.352 61.5954 339.09 89.0163L312.984 308.469C309.722 335.89 284.849 355.474 257.428 352.212L83.6531 331.54C56.2323 328.278 36.6476 303.405 39.9096 275.984L66.0158 56.5312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.513 13.2841L295.288 33.9565C322.434 37.1858 341.823 61.8105 338.594 88.9572L312.488 308.41C309.258 335.557 284.634 354.945 257.487 351.716L83.7122 331.044C56.5655 327.814 37.1767 303.19 40.4061 276.043L66.5123 56.5902L66.5918 55.9555C70.1264 29.142 94.5784 10.0799 121.513 13.2841Z",
    stroke: "black"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 77.2962,
    height: 11.5751,
    rx: 5.78753,
    transform: "matrix(-0.636954 -0.770902 -0.709404 0.704802 293.994 190.008)",
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 75.1699,
    height: 11.9027,
    rx: 5.95135,
    transform: "matrix(0.599825 -0.800131 0.741775 0.670649 240 242.146)",
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 77.2962,
    height: 11.5751,
    rx: 5.78753,
    transform: "matrix(0.636954 -0.770902 0.709404 0.704802 104 189.588)",
    fill: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 75.1699,
    height: 11.9027,
    rx: 5.95135,
    transform: "matrix(-0.599825 -0.800131 -0.741775 0.670649 157.994 241.726)",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_1",
    x: 0.269302,
    y: 0.248779,
    width: 306.461,
    height: 361.502,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0588235 0 0 0 0 0.0980392 0 0 0 0 0.14902 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_0_1",
    x: 35.5546,
    y: 12.4326,
    width: 307.891,
    height: 348.135,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0588235 0 0 0 0 0.0980392 0 0 0 0 0.14902 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlashcodeIcon2);
export default __webpack_public_path__ + "static/media/flashcode-icon_2.aa7be9a3e9273b6b5a0688e40591b15d.svg";
export { ForwardRef as ReactComponent };